exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AccordionItem-8c61abd3{border-top:1px solid #E0E0E0}.AccordionItem-8c61abd3 .titleBar-2a1d9977{height:40px;display:flex;justify-content:space-between;align-items:center;cursor:default}.AccordionItem-8c61abd3 .titleBar-2a1d9977 h3{margin:0 0}.AccordionItem-8c61abd3:last-child{border-bottom:1px solid #E0E0E0}.AccordionItem-8c61abd3 .expandIcon-1364e492{color:#757575;cursor:pointer;transform:rotate(0deg);transition:transform 200ms ease}.AccordionItem-8c61abd3 .expandIcon-1364e492.expanded-eabb4dd2{transform:rotate(180deg)}.AccordionItem-8c61abd3 .content-884f338d{padding:10px 0 20px 0}\n", ""]);

// Exports
exports.locals = {
	"AccordionItem": "AccordionItem-8c61abd3",
	"titleBar": "titleBar-2a1d9977",
	"expandIcon": "expandIcon-1364e492",
	"expanded": "expanded-eabb4dd2",
	"content": "content-884f338d"
};